import React from 'react';
import { RunResult } from '../../types';

interface SharedRunOutputPanelProps {
  runStatus: string | null;
  runResults: RunResult[];
  runError: string | null;
}

const SharedRunOutputPanel: React.FC<SharedRunOutputPanelProps> = ({
  runStatus,
  runResults,
  runError,
}) => {
  return (
    <>
      {/* Run Error */}
      {runError && (
        <div className="mb-4 p-4 bg-red-50 dark:bg-red-900/20 border border-red-200 dark:border-red-800 rounded-lg">
          <p className="text-sm text-red-700 dark:text-red-300">
            Error: {runError}
          </p>
        </div>
      )}

      {/* Run Output Panel */}
      {runStatus && runStatus !== 'error' && (
        <div className="mb-6 bg-gray-50 dark:bg-gray-900 border border-gray-200 dark:border-gray-700 rounded-lg p-4">
          <h3 className="text-sm font-semibold text-gray-900 dark:text-white mb-2">
            Output
          </h3>
          {runStatus === 'running' && (
            <p className="text-sm text-blue-600 dark:text-blue-400">Running...</p>
          )}
          {runStatus === 'completed' && runResults && runResults.length > 0 && (
            <div className="space-y-2">
              {runResults
                .filter((result: any) => result.step_type !== 'user_prompt')
                .map((result: any, index: number) => (
                <div key={result.run_result_id || index} className="text-sm text-gray-700 dark:text-gray-300 whitespace-pre-wrap">
                  {result.result_data?.output || result.final_output || JSON.stringify(result)}
                </div>
              ))}
            </div>
          )}
          {runStatus === 'completed' && (!runResults || runResults.length === 0) && (
            <p className="text-sm text-gray-500 dark:text-gray-400">Run completed.</p>
          )}
        </div>
      )}
    </>
  );
};

export default SharedRunOutputPanel;
